function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3.285 9.336l9.49-9.06a.99.99 0 0 1 1.37 0l.571.554a.918.918 0 0 1 0 1.328L6.475 10l8.233 7.842a.918.918 0 0 1 0 1.328l-.572.555a.99.99 0 0 1-1.37 0l-9.49-9.061a.925.925 0 0 1 .009-1.328z"
});

var SvgAngleLeftInline = function SvgAngleLeftInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgAngleLeftInline;